(function($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfFieldHidden', ['thfFieldHelper', '$sce',function(thfFieldHelper, $sce) {
        var link = function(scope, el) {
            scope.isValid = thfFieldHelper.isValid;
            scope.labelIdentifier = thfFieldHelper.formLabelIdentifier();

            scope.tooltip = $sce.trustAsHtml(scope.field.tooltip);

            scope.$watch('model.'+scope.field.name, function(newValue, oldValue) {
                if(oldValue !== newValue) {
                    scope.model[scope.field.name] = thfFieldHelper.escapeValue(scope.model[scope.field.name]);
                }
            }, true);
        };
        
        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'formState': '=',
                'formField': '=',
                'formModel': '=',
                'field': '=',
                'validation': '=',
                'model': '=',
                'fieldActions': '=',
                'validationRules': '='
            },
            'link': link,
            'templateUrl': function() {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/fields/hidden.html');
            }
        };
    }]);
})(jQuery, angular, window);
